"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordValidator = exports.PasswordStrength = void 0;
const types_1 = require("./types");
Object.defineProperty(exports, "PasswordStrength", { enumerable: true, get: function () { return types_1.PasswordStrength; } });
class PasswordValidator {
    static validate(password, policy = {}) {
        const fullPolicy = { ...this.DEFAULT_POLICY, ...policy };
        const errors = [];
        if (!password || typeof password !== 'string') {
            return {
                isValid: false,
                value: password,
                error: 'Password is required'
            };
        }
        if (password.length < fullPolicy.minLength) {
            errors.push(`Password must be at least ${fullPolicy.minLength} characters long`);
        }
        if (fullPolicy.maxLength && password.length > fullPolicy.maxLength) {
            errors.push(`Password must not exceed ${fullPolicy.maxLength} characters`);
        }
        if (fullPolicy.requireUppercase && !/[A-Z]/.test(password)) {
            errors.push('Password must contain at least one uppercase letter');
        }
        if (fullPolicy.requireLowercase && !/[a-z]/.test(password)) {
            errors.push('Password must contain at least one lowercase letter');
        }
        if (fullPolicy.requireNumbers && !/[0-9]/.test(password)) {
            errors.push('Password must contain at least one number');
        }
        if (fullPolicy.requireSpecialChars && !this.SPECIAL_CHARS_REGEX.test(password)) {
            errors.push('Password must contain at least one special character');
        }
        return {
            isValid: errors.length === 0,
            value: password,
            error: errors.length > 0 ? errors.join('; ') : undefined,
            errors: errors.length > 0 ? errors : undefined
        };
    }
    static calculateStrength(password) {
        if (!password)
            return types_1.PasswordStrength.WEAK;
        let score = 0;
        const checks = {
            length: password.length >= 8,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            numbers: /[0-9]/.test(password),
            specials: this.SPECIAL_CHARS_REGEX.test(password),
            longLength: password.length >= 12
        };
        score = Object.values(checks).filter(Boolean).length;
        if (score <= 2)
            return types_1.PasswordStrength.WEAK;
        if (score <= 4)
            return types_1.PasswordStrength.MEDIUM;
        if (score <= 5)
            return types_1.PasswordStrength.STRONG;
        return types_1.PasswordStrength.VERY_STRONG;
    }
    static isCommon(password) {
        const commonPasswords = [
            'password', '123456', '12345678', 'qwerty', 'abc123',
            'monkey', '1234567', 'letmein', 'trustno1', 'dragon',
            'baseball', 'iloveyou', 'master', 'sunshine', 'ashley',
            'bailey', 'passw0rd', 'shadow', '123123', '654321'
        ];
        return commonPasswords.includes(password.toLowerCase());
    }
}
exports.PasswordValidator = PasswordValidator;
PasswordValidator.DEFAULT_POLICY = {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSpecialChars: false,
    maxLength: 128
};
PasswordValidator.SPECIAL_CHARS_REGEX = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
